<script>
import { reactive, onMounted, inject } from 'vue'
import redeMarketingApi from '@/services/api/redeMarketingRepository'

export default {
  setup() {
    const swal = inject('$swal')
    const state = reactive({
      ranks: [],
      loading: true,
      recalculando: false,
    })

    function formatarPontos(valor) {
      return Number(valor || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 })
    }

    async function carregar() {
      state.loading = true
      try {
        const resp = await redeMarketingApi.ListarRanks()
        state.ranks = resp.data
      } catch (e) {
        swal({ icon: 'error', title: 'Erro', text: e.response?.data?.message || e.message })
      } finally {
        state.loading = false
      }
    }

    async function recalcularTodos() {
      swal({
        title: 'Recalcular ranks?',
        text: 'Vai recalcular o rank de TODOS os membros para a competência atual.',
        showCancelButton: true,
        confirmButtonText: 'Sim, recalcular',
        cancelButtonText: 'Cancelar',
      }).then(async (r) => {
        if (!r.isConfirmed) return
        state.recalculando = true
        try {
          await redeMarketingApi.RecalcularTodos()
          swal({
            icon: 'success',
            title: 'Iniciado',
            text: 'Recálculo em background. Atualize o Dashboard em alguns segundos.',
          })
        } catch (e) {
          swal({ icon: 'error', title: 'Erro', text: e.response?.data?.message || e.message })
        } finally {
          state.recalculando = false
        }
      })
    }

    onMounted(carregar)

    return { state, formatarPontos, recalcularTodos }
  },
}
</script>

<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
      <div class="d-flex align-items-center gap-2">
        <router-link to="/rede-marketing" class="btn btn-sm btn-light">
          <i class="material-icons align-middle">arrow_back</i>
        </router-link>
        <h3 class="mb-0">Ranks</h3>
      </div>
      <div class="d-flex gap-2">
        <router-link to="/rede-marketing/configuracao/ranks" class="btn btn-sm btn-outline-warning d-flex align-items-center">
          <i class="material-icons me-1" style="font-size: 18px;">edit</i>
          Configurar
        </router-link>
        <button class="btn btn-sm btn-primary d-flex align-items-center"
                @click="recalcularTodos" :disabled="state.recalculando">
          <i class="material-icons me-1" :class="{ girando: state.recalculando }" style="font-size: 18px;">refresh</i>
          {{ state.recalculando ? 'Recalculando...' : 'Recalcular TODOS' }}
        </button>
      </div>
    </div>

    <div v-if="state.loading" class="text-center py-5">
      <div class="spinner-border text-primary"></div>
    </div>

    <div v-else class="row g-3">
      <div v-for="rank in state.ranks" :key="rank.id" class="col-md-6 col-lg-4">
        <div class="card rank-card" :style="{ borderLeftColor: rank.corHex || '#6c757d' }">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <div>
                <h5 class="mb-0" :style="{ color: rank.corHex || '#212529' }">{{ rank.nome }}</h5>
                <code class="text-muted small">{{ rank.codigo }}</code>
              </div>
              <span class="badge bg-secondary">#{{ rank.ordem }}</span>
            </div>

            <div class="criterios">
              <div class="criterio">
                <i class="material-icons">person_add</i>
                <div>
                  <div class="fw-bold">{{ rank.minCadastrosDiretos }}</div>
                  <small class="text-muted">cadastros diretos</small>
                </div>
              </div>
              <div class="criterio">
                <i class="material-icons">stars</i>
                <div>
                  <div class="fw-bold">{{ formatarPontos(rank.minPontosMensais) }}</div>
                  <small class="text-muted">pontos/mês</small>
                </div>
              </div>
            </div>

            <span v-if="rank.ativo" class="badge bg-success mt-2">Ativo</span>
            <span v-else class="badge bg-secondary mt-2">Inativo</span>
          </div>
        </div>
      </div>
    </div>

    <div class="alert alert-info d-flex gap-2 mt-3 align-items-start">
      <i class="material-icons">info</i>
      <div>
        <strong>Recálculo automático</strong>: os ranks são recalculados no dia 1 de cada mês às 02:00.
        Para forçar manualmente, use o botão "Recalcular TODOS" acima.
      </div>
    </div>
  </div>
</template>

<style scoped>
.girando { animation: giro 1s linear infinite; }
@keyframes giro { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }

.rank-card {
  border-left: 5px solid #6c757d;
  height: 100%;
}

.criterios {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.criterio {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  background: #f8f9fa;
  border-radius: 6px;
}

.criterio i {
  color: #0d6efd;
}
</style>
